/**
 * Zähler sub-section — row cells, summary and table for kind `Zähler`.
 * Shared atoms come from `technicalAssetsSection.render.js`. Cross-file
 * references stay inside function bodies so gulp concat order does not matter.
 * Zählerstände on the property page list these same assets.
 */

const METER_TYPE_LABELS = {
  ENERGY: 'Strom',
  WATER: 'Wasser',
  GAS: 'Gas',
}

function meterTypeFields(a) {
  return (
    (a && a.typeFields && typeof a.typeFields === 'object' && a.typeFields) ||
    {}
  )
}

function meterTypeLabel(value) {
  return METER_TYPE_LABELS[String(value)] || ''
}

function renderMeterNameCell(a, ctx) {
  const tf = meterTypeFields(a)
  const type = meterTypeLabel(tf.meterType)
  const sub = [tf.meterNumber ? `Nr. ${tf.meterNumber}` : '', type]
    .filter(Boolean)
    .map((part) => escapeHtml(String(part)))
    .join(' · ')
  return `
    <div class="impowerx-ta-titleline">
      <span class="impowerx-ta-primary"><a href="${escapeHtml(ctx.detailHref(a))}">${escapeHtml(a.name || '—')}</a></span>
      ${taTag(`Z-${a.id}`)}
    </div>
    ${taSecondary(sub)}`
}

function renderMeterKindCell(a) {
  const tf = meterTypeFields(a)
  const type = meterTypeLabel(tf.meterType)
  const parts = []
  if (type) {
    parts.push(
      `<div class="impowerx-ta-titleline">${taPill(type, 'light')}</div>`
    )
  }
  if (tf.meterNumber) {
    parts.push(
      `<div class="impowerx-ta-strong" style="margin-top:4px">${escapeHtml(String(tf.meterNumber))}</div>`
    )
    parts.push(taSecondary('Zählernummer'))
  }
  return parts.length
    ? parts.join('')
    : '<span class="impowerx-ta-secondary">—</span>'
}

function renderMeterOperatorCell(a, ctx) {
  const tf = meterTypeFields(a)
  const parts = []
  if (tf.gridOperatorContactId != null) {
    parts.push(
      `<div class="impowerx-ta-strong">${escapeHtml(taContactName(ctx.contactNames, tf.gridOperatorContactId))}</div>`
    )
    parts.push(taSecondary('Netzbetreiber'))
  }
  if (tf.readingCompanyContactId != null) {
    parts.push(
      taSecondary(
        `Ablesefirma: ${escapeHtml(taContactName(ctx.contactNames, tf.readingCompanyContactId))}`
      )
    )
  }
  return parts.length
    ? parts.join('')
    : '<span class="impowerx-ta-secondary">—</span>'
}

function renderMetersSummaryHtml(rows) {
  const counts = { ENERGY: 0, WATER: 0, GAS: 0 }
  rows.forEach((a) => {
    const type = meterTypeFields(a).meterType
    if (counts[type] != null) counts[type] += 1
  })
  const bits = [
    counts.ENERGY ? `${counts.ENERGY} Strom` : '',
    counts.WATER ? `${counts.WATER} Wasser` : '',
    counts.GAS ? `${counts.GAS} Gas` : '',
  ].filter(Boolean)
  const left = `${rows.length} Zähler erfasst`
  const right = bits.length ? bits.join(' · ') : ''
  return `<div class="impowerx-ta-summary"><span class="impowerx-ta-summary-left">${TECHNICAL_ASSET_ROW_ICONS.check}${escapeHtml(left)}</span><span>${escapeHtml(right)}</span></div>`
}

function renderMetersTableHtml(rows, ctx) {
  return renderTechnicalAssetsTableShellHtml({
    columns: [
      {
        key: 'name',
        label: 'Name',
        width: 23,
        cell: renderMeterNameCell,
        sortValue: (a) => a.name,
      },
      {
        key: 'building',
        label: 'Gebäude',
        width: 16,
        cell: renderTechnicalAssetBuildingCell,
        sortValue: (a) => a.buildingLabel,
      },
      {
        key: 'kind',
        label: 'Art & Nummer',
        width: 20,
        cell: renderMeterKindCell,
        sortValue: (a) => {
          const tf = meterTypeFields(a)
          const parts = [meterTypeLabel(tf.meterType), tf.meterNumber].filter(
            Boolean
          )
          return parts.length ? parts.join(' ') : null
        },
      },
      {
        key: 'operator',
        label: 'Netzbetreiber & Ablesefirma',
        width: 31,
        cell: renderMeterOperatorCell,
        sortValue: (a, c) => {
          const tf = meterTypeFields(a)
          const id = tf.gridOperatorContactId ?? tf.readingCompanyContactId
          return id == null ? null : taContactName(c.contactNames, id)
        },
      },
    ],
    rows,
    emptyText: 'Keine Zähler erfasst.',
    deleteAriaLabel: 'Zähler löschen',
    summaryHtml: renderMetersSummaryHtml(ctx.allRows || rows),
    ctx,
  })
}
